<template>
  <div class="electron-box">
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      top="0vh"
      :show-close="false"
      :visible.sync="isfileStatusPop"
      width="580px"
      :before-close="handleClose"
    >
      <div class="d-header">
        <div class="leftOne">
          <div class="d-tit"></div>
        </div>
        <fm-button
          @click="handleClose"
          class="handleCloseaa"
          type="info"
          size="mini"
          text
          icon="icon-model-close2"
        ></fm-button>
      </div>
      <div class="AppDownFilecen">
        <img :src="$utils.getPng(consumeInfo.img)" class="fileStatusPop1" />
        <div class="cen-box">
          <div class="title">{{ consumeInfo.title_down }}</div>
          <div class="cen" v-html="consumeInfo.content_down"></div>
          <fm-button class="fmButton" round size="medium" @click="govip"
            >{{ consumeInfo.btnText || "" }}
          </fm-button>
          <div
            v-if="
              consumeInfo?.e?.errorCode == 81001 &&
              $store.state.userInfo.is_vip == 0
            "
            @click="gowelfare"
            class="qianwang"
          >
            前往福利社获取
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isfileStatusPop: {
      type: Boolean,
      default: false,
    },
    consumeInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    gowelfare() {
      window.open("/welfare");
    },
    govip() {
      if (this.consumeInfo.vip_update == 0) {
        this.handleClose();
      } else {
        window.open("/vip");
      }
    },
    handleClose() {
      this.$emit("Visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .handleCloseaa{
  .svg-icon {
    width: 20px !important;
    height: 20px !important;
  }

}
::v-deep .el-dialog {
  height: auto;
}
::v-deep .el-dialog__body {
  display: flex;
  flex-direction: column;
  padding: 0 !important;
}
.leftOne {
  display: flex;
  align-items: center;
  .d-tit {
    font-size: 16px;
    font-weight: 500;
    @include useTheme {
      color: getVar("text-color1-2c2c2c");
    }
  }

  .d-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
.AppDownFilecen {
  .fileStatusPop1 {
    width: 100%;
    height: 280px;
  }
  .cen-box {
    width: 100%;
    padding: 24px 24px 32px 24px;
    .title {
      // height: 26px;
      font-weight: 500;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 26px;
      margin-bottom: 8px;
      @include useTheme {
        color: getVar("text-color1-2c2c2c");
      }
    }
    .cen {
      // height: 22px;
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 22px;
      @include useTheme {
        color: getVar("text-color1-2c2c2c");
      }
    }
    .fmButton {
      margin: 32px auto;
      margin-bottom: 0;
      width: 320px;
      height: 48px;
      border-radius: 22px;
    }
    .qianwang {
      height: 22px;
      font-weight: 400;
      font-size: 14px;
      color: #f67942;
      line-height: 22px;
      text-align: center;
      margin-top: 8px;
      cursor: pointer;
    }
  }
}
</style>
